import PriceDisplay from './PriceDisplay';

export default PriceDisplay;


// WEBPACK FOOTER //
// ./src/components/Others/PriceDisplay/index.tsx